var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"Checklist",attrs:{"href":`${_vm.baseUrl}checklist/${_vm.subId}`}},[_c('time',{attrs:{"datetime":_vm.date}},[_c('strong',[_vm._v(_vm._s(_vm.dateDisplay))]),_vm._v(" "+_vm._s(_vm.timeDisplay))])])
}
var staticRenderFns = []

export { render, staticRenderFns }